import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../services/UserContext";
import useFetch from "../../../services/functions/useFetch";
import snowflake from "../../../assets/icons/loading-snowflake.svg";
import CustomAlert from "../../CustomAlert";
import useAnimation from "../../../services/functions/useAnimation";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { refreshSession } = useUser();
  const { error, isPending, fetchData } = useFetch();
  const { slideIn } = useAnimation();

  useEffect(() => {
    slideIn(".section-container");
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    fetchData("/login", "POST", {
      body: {
        username: username,
        password: password,
      },
      doOnSuccess: async () => {
        await refreshSession(); // Refresh session status after login
        navigate("/"); // Redirect after successful login
      },
      doOnError: () => {
        setPassword("");
        setUsername("");
      },
    });
  };

  return (
    <>
      {error && <CustomAlert message={error} type="error" />}
      <section className="section-container">
        <div className="content-wrapper">
          <div className="form-container">
            <h1 className="form-title">Anmeldung</h1>
            <form className="form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="username" className="form-label">
                  Benutzername
                </label>
                <input
                  type="username"
                  name="username"
                  id="username"
                  className="form-input"
                  placeholder="MaxMustermann"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  Passwort
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  className="form-input"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button className="form-button">
                Einloggen
                {isPending && (
                  <img
                    src={snowflake}
                    alt="loading"
                    className="loading-snowflake loading-snowflake--small"
                  />
                )}
              </button>{" "}
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
